// 003 (FR-002, FR-004, FR-006 to FR-010; data-model §4): one lookup turned into what the screens
// show. A malformed code makes no request (the lookup is rate-limited per IP).
import { type AppError, isAppError, toAppError } from "@/api/errors";
import type { Api } from "@/api/types";

import { isValidSchoolCode } from "./schoolCode";

export type LookupResult =
  | { kind: "active"; school: Api["SchoolByCode"] }
  | { kind: "notActive"; name: string }
  | { kind: "invalid" }
  | { kind: "rateLimited"; retryAfterSeconds: number | null }
  | { kind: "error"; error: AppError };

export type LookupState =
  | { status: "loading" }
  | ({ status: "done" } & LookupResult);

export async function lookupSchool(
  get: (code: string) => Promise<Api["SchoolByCode"]>,
  code: string,
): Promise<LookupResult> {
  if (!isValidSchoolCode(code)) return { kind: "invalid" };
  try {
    const school = await get(code);
    return school.status === "ACTIVE"
      ? { kind: "active", school }
      : { kind: "notActive", name: school.name };
  } catch (thrown) {
    const error = isAppError(thrown)
      ? thrown
      : toAppError({ thrown, timedOut: false });
    if (error.kind === "notFound") return { kind: "invalid" };
    if (error.kind === "rateLimited")
      return { kind: "rateLimited", retryAfterSeconds: error.retryAfterSeconds };
    return { kind: "error", error };
  }
}
